"use strict";
//******************************************************************************
// Copyright 2018-2020, ShareSquared Inc., All Rights Reserved.
//
// Author:  Ted Iverson
// Created: 06/22/2020
//
// The contents of this file are proprietary and considered trade secret.
// Any disclosure outside of its intended use is expressly prohibited.
//******************************************************************************
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
//#region Imports
var React = require("react");
require("jquery/src/jquery");
var Label_1 = require("@fluentui/react/lib/Label");
var Button_1 = require("@fluentui/react/lib/Button");
var DatePicker_1 = require("@fluentui/react/lib/DatePicker");
var TextField_1 = require("@fluentui/react/lib/TextField");
var Dropdown_1 = require("@fluentui/react/lib/Dropdown");
var react_bootstrap_1 = require("react-bootstrap");
var SearchPanel = /** @class */ (function (_super) {
    __extends(SearchPanel, _super);
    function SearchPanel(props, state) {
        var _this = _super.call(this, props, state) || this;
        // tracks the properties of each field on the form so we can have the information
        // during the building of the query (mainly Type and Mapped Property)
        _this.formFieldProps = new Map();
        _this.state = { FormValues: {}, KeywordText: "" };
        return _this;
    }
    SearchPanel.prototype.renderField = function (field, idx) {
        var _this = this;
        var f;
        switch (field.fieldType.toLowerCase()) {
            default:
            case "text": {
                var id_1 = "txt_" + idx;
                this.formFieldProps.set(id_1, { Id: id_1, Type: field.fieldType, PropertyName: field.property, });
                f = (React.createElement(TextField_1.TextField, { id: id_1, key: id_1, label: field.label, className: "S2Input S2TextField", value: this.state.FormValues[id_1], onChange: function (evt, v) {
                        if (v !== undefined) {
                            var o = _this.state.FormValues;
                            o[id_1] = v;
                            _this.setState({ FormValues: o });
                        }
                    } }));
                break;
            }
            case "date": {
                var id1_1 = "sd_" + idx;
                this.formFieldProps.set(id1_1, { Id: id1_1, Type: field.fieldType, PropertyName: field.property });
                var id2_1 = "ed_" + idx;
                this.formFieldProps.set(id2_1, { Id: id2_1, Type: field.fieldType, PropertyName: field.property });
                f = (React.createElement("span", { key: "spandt_" + idx },
                    React.createElement(DatePicker_1.DatePicker, { id: id1_1, key: id1_1, label: field.label, className: "S2Input S2DateField S2ComboField", title: "on or after", placeholder: "on or after", allowTextInput: true, value: this.state.FormValues[id1_1], onSelectDate: function (dt) {
                            if (dt !== undefined && dt !== null) {
                                var o = _this.state.FormValues;
                                o[id1_1] = dt;
                                _this.setState({ FormValues: o });
                            }
                        } }),
                    React.createElement(DatePicker_1.DatePicker, { id: id2_1, key: id2_1, className: "S2Input S2DateField", title: "before or on", placeholder: "before or on", allowTextInput: true, textField: { onRenderLabel: function (props) { return (React.createElement(Label_1.Label, null, "\u00A0")); } }, value: this.state.FormValues[id2_1], onSelectDate: function (dt) {
                            if (dt !== undefined && dt !== null) {
                                var o = _this.state.FormValues;
                                o[id2_1] = dt;
                                _this.setState({ FormValues: o });
                            }
                        } })));
                break;
            }
            case "number": {
                var id1_2 = "ln_" + idx;
                this.formFieldProps.set(id1_2, { Id: id1_2, Type: field.fieldType, PropertyName: field.property });
                var id2_2 = "hn_" + idx;
                this.formFieldProps.set(id2_2, { Id: id2_2, Type: field.fieldType, PropertyName: field.property });
                f = (React.createElement("span", { key: "spannum_" + idx },
                    React.createElement(TextField_1.TextField, { id: id1_2, key: id1_2, label: field.label, className: "S2Input S2NumberField S2ComboField", title: "equal to or greater", placeholder: "equal to or greater", value: this.state.FormValues[id1_2], onChange: function (evt, v) {
                            if (v !== undefined) {
                                var o = _this.state.FormValues;
                                o[id1_2] = v;
                                _this.setState({ FormValues: o });
                            }
                        } }),
                    React.createElement(TextField_1.TextField, { id: id2_2, key: id2_2, className: "S2Input S2NumberField", title: "less than or equal", placeholder: "less than or equal", onRenderLabel: function (props) { return (React.createElement(Label_1.Label, null, "\u00A0")); }, value: this.state.FormValues[id2_2], onChange: function (evt, v) {
                            if (v !== undefined) {
                                var o = _this.state.FormValues;
                                o[id2_2] = v;
                                _this.setState({ FormValues: o });
                            }
                        } })));
                break;
            }
            case "boolean": {
                var id_2 = "bool_" + idx;
                this.formFieldProps.set(id_2, { Id: id_2, Type: field.fieldType, PropertyName: field.property });
                f = (React.createElement(Dropdown_1.Dropdown, { id: id_2, key: id_2, label: field.label, className: "S2Input S2BooleanField", options: [
                        { key: '', text: '' },
                        { key: '1', text: 'Yes' },
                        { key: '0', text: 'No' }
                    ], selectedKey: this.state.FormValues[id_2], onChange: function (evt, v) {
                        if (v !== undefined) {
                            var o = _this.state.FormValues;
                            o[id_2] = v.key;
                            _this.setState({ FormValues: o });
                        }
                    } }));
                break;
            }
            case "list": {
                var id_3 = "lst_" + idx;
                this.formFieldProps.set(id_3, { Id: id_3, Type: field.fieldType, PropertyName: field.property });
                f = (React.createElement(Dropdown_1.Dropdown, { id: id_3, key: id_3, className: "S2Input S2ListField", placeholder: "Select option(s)", label: field.label, multiSelect: true, options: field.options.map(function (o) {
                        return { key: o, text: o };
                    }), selectedKeys: this.state.FormValues[id_3] !== undefined ? this.state.FormValues[id_3].split(";") : [], onChange: function (evt, v) {
                        var curOptions = _this.state.FormValues[id_3] !== undefined ? _this.state.FormValues[id_3].split(";") : [];
                        var foundIndex = curOptions.indexOf(v === null || v === void 0 ? void 0 : v.key);
                        if ((v === null || v === void 0 ? void 0 : v.selected) && foundIndex === -1)
                            curOptions.push(v === null || v === void 0 ? void 0 : v.key);
                        if (!(v === null || v === void 0 ? void 0 : v.selected) && foundIndex !== -1)
                            curOptions.splice(foundIndex, 1);
                        var o = _this.state.FormValues;
                        o[id_3] = curOptions.join(";");
                        _this.setState({ FormValues: o });
                    } }));
                break;
            }
        }
        return f;
    };
    SearchPanel.prototype.renderCol = function (fields, rowsPerCol, colNumber) {
        var _this = this;
        return (React.createElement(react_bootstrap_1.Col, { key: "col_" + colNumber, lg: "4" }, fields.map(function (f, idx) {
            return _this.renderField(f, (idx + 1) + (colNumber * rowsPerCol));
        })));
    };
    SearchPanel.prototype.renderFormRows = function () {
        var template = this.props.Template;
        // split the fields across the 3 columns and render
        var RowsPerCol = Math.ceil(template.form.fields.length / 3);
        var rows = [];
        rows.push(this.renderCol(template.form.fields.slice(0, RowsPerCol), RowsPerCol, 0));
        rows.push(this.renderCol(template.form.fields.slice(RowsPerCol, (RowsPerCol * 2)), RowsPerCol, 1));
        rows.push(this.renderCol(template.form.fields.slice(RowsPerCol * 2), RowsPerCol, 2));
        return (React.createElement(react_bootstrap_1.Row, null, rows));
    };
    SearchPanel.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "S2SearchForm", onKeyUp: function (event) {
                if (event.keyCode === 13) {
                    _this.searchClicked();
                }
            } },
            React.createElement(react_bootstrap_1.Container, null,
                React.createElement(react_bootstrap_1.Row, null,
                    React.createElement(react_bootstrap_1.Col, { lg: "9" },
                        React.createElement(TextField_1.TextField, { className: "S2Search", label: "Keywords", value: this.state.KeywordText, onChange: function (evt, v) {
                                if (v !== undefined) {
                                    _this.setState({ KeywordText: v });
                                }
                            } })),
                    React.createElement(react_bootstrap_1.Col, { lg: "3" },
                        React.createElement("span", { className: "S2SearchFormButtons" },
                            React.createElement(Button_1.PrimaryButton, { className: "S2SearchButton", text: "Search", onClick: function () { _this.searchClicked(); } }),
                            React.createElement(Button_1.DefaultButton, { className: "S2ClearButton", text: "Clear", onClick: function () { _this.clearClicked(); } })))),
                (this.props.Template !== null) ? this.renderFormRows() : null)));
    };
    SearchPanel.prototype.setErrorMessage = function (message) {
        if (this.props.OnError)
            this.props.OnError(message);
    };
    SearchPanel.prototype.validateDateRanges = function () {
        var _this = this;
        var valid = true;
        this.formFieldProps.forEach(function (f) {
            if (f.Id.indexOf("sd_") !== -1) {
                var sv = _this.state.FormValues[f.Id];
                var ev = _this.state.FormValues[f.Id.replace("sd", "ed")];
                if (sv !== undefined && sv !== null && ev !== undefined && ev !== null) {
                    var sdt = Date.parse(sv);
                    var edt = Date.parse(ev);
                    if (sdt > edt) {
                        _this.setErrorMessage("There are date-sequencing errors");
                        valid = false;
                    }
                }
            }
        });
        return valid;
    };
    SearchPanel.prototype.validateNumberRanges = function () {
        var _this = this;
        var valid = true;
        this.formFieldProps.forEach(function (f) {
            if (f.Id.indexOf("ln_") !== -1) {
                var sv = _this.state.FormValues[f.Id];
                var ev = _this.state.FormValues[f.Id.replace("ln", "hn")];
                if (sv !== undefined && sv !== null && ev !== undefined && ev !== null) {
                    var sdt = parseFloat(sv);
                    var edt = parseFloat(ev);
                    if (sdt > edt) {
                        _this.setErrorMessage("There are number-sequencing errors");
                        valid = false;
                    }
                }
            }
        });
        return valid;
    };
    SearchPanel.prototype.buildQuery = function () {
        var _this = this;
        var qry = this.state.KeywordText;
        var prevValue = "";
        this.formFieldProps.forEach(function (f) {
            var value = _this.state.FormValues[f.Id];
            if (value !== undefined && value !== null && value.length !== 0) {
                if (qry.length !== 0)
                    qry += " ";
                switch (f.Type.toLowerCase()) {
                    default:
                    case "text": {
                        qry += f.PropertyName + ":\"" + value + "\"";
                        break;
                    }
                    case "date": {
                        // NOTE: since ranges are ANDs, we need to handle the grouping
                        if (f.Id.indexOf("sd_") !== -1) {
                            var ev = _this.state.FormValues[f.Id.replace("sd", "ed")];
                            if (ev !== undefined && ev !== null)
                                qry += "(";
                            prevValue = value;
                        }
                        else {
                            if (prevValue.length !== 0)
                                qry += "AND ";
                        }
                        var op = (f.Id.indexOf("sd_") !== -1) ? ">=" : "<=";
                        var dt = new Date(Date.parse(value));
                        qry += "" + f.PropertyName + op + ("" + dt.getFullYear() + "-" + _this.zeroPad(dt.getMonth() + 1) + "-" + _this.zeroPad(dt.getDate()));
                        if (f.Id.indexOf("ed_") !== -1) {
                            if (prevValue.length !== 0)
                                qry += ")";
                            prevValue = "";
                        }
                        break;
                    }
                    case "number": {
                        // NOTE: since ranges are ANDs, we need to handle the grouping
                        if (f.Id.indexOf("ln_") !== -1) {
                            var ev = _this.state.FormValues[f.Id.replace("sd", "ed")];
                            if (ev !== undefined && ev !== null)
                                qry += "(";
                            prevValue = value;
                        }
                        else {
                            if (prevValue.length !== 0)
                                qry += "AND ";
                        }
                        var op = (f.Id.indexOf("ln_") !== -1) ? ">=" : "<=";
                        qry += "" + f.PropertyName + op + value;
                        if (f.Id.indexOf("hn_") !== -1) {
                            if (prevValue.length !== 0)
                                qry += ")";
                            prevValue = "";
                        }
                        break;
                    }
                    case "boolean": {
                        qry += f.PropertyName + "=" + value;
                        break;
                    }
                    case "list": {
                        // NOTE: lists are multi-select and are handled implicitly by
                        // SharePoint search as ORs
                        value.split(";").forEach(function (v, idx) {
                            if (v.length !== 0) {
                                if (idx !== 0)
                                    qry += " ";
                                //qry += `${f.PropertyName}:"${v}"`;
                                qry += f.PropertyName + "=\"" + v + "\"";
                            }
                        });
                        break;
                    }
                }
            }
        });
        // wrap the query with the QueryTemplate if one is defined, otherwise
        // just use the provided query as is
        var Query = !this.props.Template.queryTemplate || this.props.Template.queryTemplate.length === 0 ?
            qry :
            this.props.Template.queryTemplate.replace("{{query}}", qry);
        return Query;
    };
    SearchPanel.prototype.zeroPad = function (num) {
        var s = '';
        if (num < 10) {
            s = '0';
        }
        s += num.toString();
        return s;
    };
    SearchPanel.prototype.searchClicked = function () {
        if (this.validateDateRanges() && this.validateNumberRanges()) {
            if (this.props.OnSearch !== undefined) {
                var qry = this.buildQuery();
                //console.log(`qry: ${qry}`);
                this.props.OnSearch(qry);
            }
        }
    };
    SearchPanel.prototype.clearClicked = function () {
        var o = this.state.FormValues;
        this.formFieldProps.forEach(function (f) {
            o[f.Id] = "";
        });
        this.setState({ FormValues: o, KeywordText: "" });
        if (this.props.OnClear !== undefined)
            this.props.OnClear();
    };
    return SearchPanel;
}(React.Component));
exports.default = SearchPanel;
//# sourceMappingURL=SearchForm.js.map